/// <amd-module name="Reporting/BoardsCommon/Pickers/BacklogCategoryPickerHelpers" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { WorkItemBacklogFilter } from "./WorkItemBacklogFilter";

/** A narrow definition of the aspect of the Backlog Configuration required for Burndown Report. */
interface BacklogConfigPayload {
    taskBacklog: {
        /** The friendly name */
        name: string;
        /** The reference name */
        id: string;
    };
}

/**  Get the task backlog name from the boards service for the current project */
export async function getTaskBacklogCategoryReferenceName(pageContext: IVssPageContext): Promise<string> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const backlogConfigurationData = (await contributionService.getDataAsync(
        "ms.vss-work-web.agile-backlog-configuration-data-provider"
    )) as BacklogConfigPayload;
    const backlogCategoryReferenceName = backlogConfigurationData.taskBacklog.id;
    return backlogCategoryReferenceName;
}

/** Populates a default work item filter if one isn't present */
export async function ensureWorkItemFilter(
    pageContext: IVssPageContext,
    workItemTypeFilterSetting?: WorkItemBacklogFilter
): Promise<WorkItemBacklogFilter> {
    let workItemTypeFilter: WorkItemBacklogFilter;
    if (workItemTypeFilterSetting != null) {
        workItemTypeFilter = workItemTypeFilterSetting;
    } else {
        const taskBacklogCategoryReferenceName = await getTaskBacklogCategoryReferenceName(pageContext);
        workItemTypeFilter = {
            identifier: "BacklogCategory",
            settings: taskBacklogCategoryReferenceName
        };
    }
    return workItemTypeFilter;
}
